/* eslint-disable @typescript-eslint/naming-convention */

const styles = {
  global: {
    'html, body': {
      overflowX: 'unset',
    },
  },
}
export default styles
